exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table tbody tr td:last-child {\n  width: 1%;\n  white-space: nowrap;\n}\n", ""]);

// exports
